
if (!customElements.get('search-suggestions')) {
  class SearchSuggestions extends HTMLElement {
    connectedCallback() {
      this.searchTimeoutID = null;
      this.oldSearchValue = '';
      this.searchSuggestionsAbortController = null;

      this.searchInput = this.closest('form')?.querySelector(
        'input[name="q"]'
      );

      if (!this.searchInput) return;

      this.handleInput = this.handleInputChange.bind(this);

      this.searchInput.addEventListener(
        'input',
        this.handleInput
      );
    }

    disconnectedCallback() {
      if (this.searchInput && this.handleInput) {
        this.searchInput.removeEventListener(
          'input',
          this.handleInput
        );
      }

      clearTimeout(this.searchTimeoutID);

      if (this.searchSuggestionsAbortController) {
        this.searchSuggestionsAbortController.abort();
      }
    }

    handleInputChange() {
      const searchTerm = this.searchInput.value.trim();

      clearTimeout(this.searchTimeoutID);

      if (this.searchSuggestionsAbortController) {
        this.searchSuggestionsAbortController.abort();
        this.searchSuggestionsAbortController = null;
      }

      if (!searchTerm) {
        this.innerHTML = '';
        this.oldSearchValue = '';
        return;
      }

      if (searchTerm === this.oldSearchValue) return;

      this.oldSearchValue = searchTerm;

      this.searchTimeoutID = setTimeout(() => {
        this.fetchSuggestions(searchTerm);
      }, 300);
    }

    async fetchSuggestions(searchTerm) {
      const controller = new AbortController();

      this.searchSuggestionsAbortController = controller;

      try {
        const params = new URLSearchParams();

        params.set('q', searchTerm);
        params.set('section_id', 'search-suggestions');

        // Request up to 10 results per resource type.
        params.set('resources[limit]', '10');

        // Prevent other resource types from sharing
        // the product result limit.
        params.set('resources[limit_scope]', 'each');

        const url =
          `${theme.routes.predictiveSearch}?${params.toString()}`;

        const response = await fetch(url, {
          signal: controller.signal
        });

        if (!response.ok) {
          throw new Error(
            `Predictive search failed: ${response.status}`
          );
        }

        const html = await response.text();

        // Ignore results from an outdated search.
        if (
          controller.signal.aborted ||
          this.searchInput.value.trim() !== searchTerm
        ) {
          return;
        }

        const parsedDocument = new DOMParser().parseFromString(
          html,
          'text/html'
        );

        const results = parsedDocument.querySelector(
          '.search-suggestions-wrapper'
        );

        if (!results || !results.firstElementChild) {
          this.innerHTML = '';
          return;
        }

        // Preserve Symmetry's existing result markup.
        this.replaceChildren(
          results.firstElementChild
        );

      } catch (error) {
        if (error.name === 'AbortError') return;

        console.warn(
          'Search suggestions error:',
          error
        );
      } finally {
        if (this.searchSuggestionsAbortController === controller) {
          this.searchSuggestionsAbortController = null;
        }
      }
    }
  }

  customElements.define(
    'search-suggestions',
    SearchSuggestions
  );
}
